import Carousel from "react-bootstrap/Carousel";
import './YoutubeCarousel.css';
import React, {Component} from "react";
import {Link} from "react-router-dom";

let ytOpts = {
    height: (390 * 1.5).toString(),
    width: (640 * 1.5).toString(),
    playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
        playsinline: 0
    }
};

function ytThumbnail(videoID) {
    return "https://img.youtube.com/vi/" + videoID + "/hqdefault.jpg";
}

class YoutubeCarousel extends Component {

    render() {
        let {appData} = this.props;
        const youtubeVideos = appData.youtubeVideos;
        let ytVidIdx = appData.selectedYoutubeVid;

        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            ytOpts.height = (390 * 0.6).toString();
            ytOpts.width = (640 * 0.6).toString();
        }
        return (
            <Carousel style={{marginTop: '0rem', minWidth: ytOpts.width, minHeight: ytOpts.height}} controls={false}>
                {
                    youtubeVideos.map(function (video, idx) {
                        return (
                            <Carousel.Item>

                                <Link
                                    onClick={() => {
                                        appData.selectedYoutubeVid = idx;
                                    }}
                                    to="/video">
                                    <img
                                        src={ytThumbnail(video.id)}
                                        width={ytOpts.width}
                                        height={ytOpts.height}
                                    />
                                </Link>
                            </Carousel.Item>
                        );
                    })
                }
            </Carousel>
        );
    }
}

export default YoutubeCarousel;